var App = App || {};

App.Alert = (function ($) {
    "use strict";

    function init() {
        var $header = $("header"),
            $alert = $header.find(".alert-dismissible"),
            alertId;

        $.each($alert, function () {
            alertId = $(this).attr("id");

            if (localStorage["alert-" + alertId] === "closed") {
                $(this).remove();
            } else {
                $(this).removeClass("d-none");
            }
        });

        $alert.on("closed.bs.alert", function () {
            alertId = $(this).attr("id");
            localStorage["alert-" + alertId] = "closed";

            Stickyfill.refreshAll();
        });

        Stickyfill.refreshAll();
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.Alert.init();
});